export default __webpack_public_path__ + "static/media/floppy-disk.1a3ecd1e.png";